export default __webpack_public_path__ + "static/step-one-both-do-13c6b0e97272505b9558a451afb03af9.png";